import { CommonModule } from '@angular/common';
import { Component, effect, Input } from '@angular/core';
import { AppStateService } from 'app/services/app-state.service';

@Component({
  selector: 'app-primary-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './primary-header.component.html',
  styleUrl: './primary-header.component.scss'
})
export class PrimaryHeaderComponent {
  @Input() fontSize: string = "18px"
  @Input() mobileFontSize: string = null;
  @Input() lineHeight: number = 1.2
  @Input() mt: string = "0px";
  @Input() mb: string = "20px";

  currentSize: string = '';

  constructor(private appState: AppStateService) {
    effect(() => {
      const isMobile = this.appState.device.isMobile();
      if (isMobile && this.mobileFontSize !== null) {
        this.currentSize = this.mobileFontSize
      } else {
        this.currentSize = this.fontSize;
      }
    })
  }

}
